import { render, staticRenderFns } from "./CompanyMember.vue?vue&type=template&id=33131c40&scoped=true&"
import script from "./CompanyMember.vue?vue&type=script&lang=js&"
export * from "./CompanyMember.vue?vue&type=script&lang=js&"
import style0 from "./CompanyMember.vue?vue&type=style&index=0&id=33131c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33131c40",
  null
  
)

export default component.exports